/* Editorial Story 🛠️ — sections/custom-editorial.liquid
 * Gently fades each quote / figure up as it scrolls into view. Content is visible by default;
 * the hidden starting state only applies once this script has run (and never with reduced motion).
 * Gallery / full-width videos play only while on screen (they're preload="none", so nothing
 * downloads until they're nearly in view) and pause when scrolled away. With reduced motion they
 * stay on their poster image. */

if (!customElements.get('editorial-story')) {
  class EditorialStory extends HTMLElement {
    // connected/disconnected also run when the theme editor re-renders the section.
    connectedCallback() {
      const items = this.querySelectorAll('.editorial__reveal');
      if (!items.length || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          this.observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -10% 0px' });
      items.forEach((el) => this.observer.observe(el));
      this.classList.add('is-ready');
      this.watchVideos();
    }

    watchVideos() {
      const videos = this.querySelectorAll('video.editorial__video');
      if (!videos.length || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.videoObserver = new IntersectionObserver((entries) => {
        entries.forEach(({ target: video, isIntersecting }) => {
          if (isIntersecting) {
            video.preload = 'auto';
            video.play().catch(() => {}); // autoplay blocked (e.g. low-power mode): the poster stays
          } else {
            video.pause();
          }
        });
      }, { rootMargin: '200px 0px', threshold: 0.1 });
      videos.forEach((v) => this.videoObserver.observe(v));
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.videoObserver?.disconnect();
    }
  }

  customElements.define('editorial-story', EditorialStory);
}
